export function hasRole(user, roles = []) {
    if (!Array.isArray(roles)) {
        roles = [roles];
    }

    if (!roles.length) {
        return true;
    }

    if (!user || !user.roles) {
        return false;
    }

    if (user.roles.length && user.roles.includes('root')) {
        return true;
    }

    return roles.some(role => user.roles.includes(role));
}

export function foo() {
    console.log('foo');
    return 'foo';
}

export function isMobile() {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
}
export function request_image(onImageSelected) {
    if (!onImageSelected || typeof onImageSelected !== 'function')
        throw new Error('onImageSelected must be a function');

    const input = document.createElement('input');
    input.type = 'file';
    input.accept = 'image/*';
    input.setAttribute('capture', 'environment');
    input.style.display = 'none';

    document.body.appendChild(input);

    input.onchange = () => {
        if (input.files && input.files.length > 0) {
            onImageSelected(input.files[0]);
        } else {
            console.log('No image selected');
        }

        input.remove();
    };

    input.value = null;

    setTimeout(() => input.click(), 100);
}

export function base64ToBlob(base64, mime) {
    const byteChars = atob(base64);
    const byteNumbers = new Array(byteChars.length);
    for (let i = 0; i < byteChars.length; i++) {
        byteNumbers[i] = byteChars.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    return new Blob([byteArray], { type: mime });
}

export function compressImage(file, maxWidth = 1024, quality = 0.8) {
    return new Promise((resolve, reject) => {
        const img = new Image();
        const reader = new FileReader();

        reader.onload = function (e) {
            img.src = e.target.result;
        };

        img.onload = function () {
            const canvas = document.createElement('canvas');
            const scale = maxWidth / img.width;
            canvas.width = maxWidth;
            canvas.height = img.height * scale;
            const ctx = canvas.getContext('2d');
            ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

            canvas.toBlob((blob) => {
                resolve(blob);
            }, 'image/jpeg', quality);
        };

        reader.onerror = reject;
        img.onerror = reject;

        reader.readAsDataURL(file);
    });
}